<template>
<div class="controller">
  <ul class="action_buttons">
    <li class="column_add action_button">
      <router-link :to='router' class="add_router">
        {{columnAdd}}
      </router-link>
    </li>
  </ul>
  <div class="complete_modal_window" v-if='showCompleteModal'>
    <completeModalWindow :question='completeWord' @close="closeModal">
    </completeModalWindow>
  </div>
  <div class="false_modal_window" v-if='showFalseModal'>
    <completeModalWindow :question='falseWord' @close="close">
    </completeModalWindow>
  </div>
</div>
</template>

<script>
import completeModalWindow from '../../../modalWindow/finishModalWindow.vue'

export default {
  props: ['router'],
  data () {
    return {
      columnAdd: '追加',
      falseWord: '',
      completeWord: '',
      showCompleteModal: false,
      showFalseModal: false,
      inputValue: ''
    }
  },
  computed: {
  },
  components: {
    completeModalWindow
  },
  methods: {
    close (e) {
      this.showFalseModal = false
    },
    closeModal (e) {
      this.showCompleteModal = false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/controller.vue